import Cookies from 'js-cookie'

export const setCookie = (name: string, value: string, expiresDays: number) => {
  Cookies.set(name, value, { expires: expiresDays })
}

export const getCookie = (name: string) => {
  const cookieValue = Cookies.get(name)
  return cookieValue
}

export const deleteCookie = (name: string[]) => {
  name.map(name => Cookies.remove(name))
}
